import { Reducer } from "redux";
import { PanelState, PanelTypes } from "./types";

export const INITIAL_STATE: PanelState = {
  data: [],
  origin: [{ id: 1, origin_name: "TODAS" }],
  loadingData: false,
  loadingOrigin: false,
  success: false,
  error: false
};

const reducer: Reducer<PanelState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PanelTypes.LOAD_REQUEST:
      return { ...state, loadingData: true, success: false, error: false };
    case PanelTypes.LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loadingData: false,
        success: true,
        error: false,
      };

    case PanelTypes.LOAD_REQUEST_ORIGIN:
      return { ...state, loadingOrigin: true, success: false, error: false };
    case PanelTypes.LOAD_SUCCESS_ORIGIN:
      return {
        ...state,
        origin: action.payload,
        loadingOrigin: false,
        success: true,
        error: false,
      };

    case PanelTypes.LOAD_FAILURE:
      return {
        ...state,
        loadingData: false,
        loadingOrigin: false,
        error: true,
        success: false,
      };

    default:
      return state;
  }
};

export default reducer;
